class ProductDescriptionTruncate extends HTMLElement {
  constructor() {
    super();

    this.showMoreButton = this.querySelector('.description__show-more-btn');
    this.showLessButton = this.querySelector('.description__show-less-btn');
    this.shortContainer = this.querySelector('.product__description-short');
    this.fullContainer = this.querySelector('.product__description-full');
  }

  connectedCallback() {
    this.showMoreButton.addEventListener('click', () => {
      this.shortContainer.style.display = 'none';
      this.fullContainer.style.display = 'block';
    })

    this.showLessButton.addEventListener('click', () => {
      this.shortContainer.style.display = 'block';
      this.fullContainer.style.display = 'none';
    })
  }
}

customElements.define('product-description-truncate', ProductDescriptionTruncate);
